<template>
    <div style="background: #f3f3f3">
        <div v-if="inspectDeviceDetail.inspectTask!=null">
            <CellGroup title="任务信息">
                <Cell title="任务名称" :value="inspectDeviceDetail.inspectTask.name"/>
                <Cell title="所属区域" :value="inspectDeviceDetail.areaName"/>
                <Cell title="所属单位" :value="inspectDeviceDetail.unitName"/>
                <Cell title="开始时间" :value="inspectDeviceDetail.inspectTask.startTime"/>
                <Cell title="结束时间" :value="inspectDeviceDetail.inspectTask.endTime"/>
            </CellGroup>
        </div>
        <CellGroup title="设备信息">
            <Cell title="设备名称" :value="inspectDeviceDetail.device.name"/>
            <Cell title="设备编号" :value="inspectDeviceDetail.device.sn"/>
            <!--<Cell title="所属区域" :value="inspectDeviceDetail.device.areaName"/>-->
            <!--<Cell title="所属单位" :value="inspectDeviceDetail.device.unitName"/>-->
            <Cell title="安装位置" :value="inspectDeviceDetail.device.installLocation"/>
        </CellGroup>
        <div v-if="inspectDeviceDetail.handleUser!=null">
            <CellGroup title="处理信息">
                <Cell title="处理人" :value="inspectDeviceDetail.handleUserRealName"/>
                <Cell title="处理方式" :value="handleMethod"/>
                <Cell title="处理意见" :value="inspectDeviceDetail.handleRemark"/>
                <Cell title="处理时间" :value="inspectDeviceDetail.handleTime"/>
                <Cell title="处理照片"/>
                <div
                        style="display:flex;justify-content : space-between;width:90%;margin:auto;margin-top:8px;"
                >
                    <UploadImage style="margin-left:-15px" :imageList="[inspectDeviceDetail.handleImage1]" top="照片1"
                                 :count="1"/>
                    <UploadImage style="margin-left:-15px" :imageList="[inspectDeviceDetail.handleImage2]" top="照片2"
                                 :count="1"/>
                    <UploadImage style="margin-left:-15px" :imageList="[inspectDeviceDetail.handleImage3]" top="照片3"
                                 :count="1"/>
                    <UploadImage style="margin-left:-15px" :imageList="[inspectDeviceDetail.handleImage4]" top="照片4"
                                 :count="1"/>
                </div>
            </CellGroup>
        </div>
        <Button v-if="inspectDeviceDetail.state=='UN_HANDLE'" type="info"
                @click="$router.push('/inspect/deal/' + deviceId)" block
                class="fixed-bottom-button">开始处理
        </Button>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Dialog, Popup} from 'vant';
    import UploadImage from "@/components/UploadImage";
    import * as DICT from "@/utils/dict"

    export default {
        components: {UploadImage, Button, Popup, CellGroup, Cell, Dialog},
        props: {},
        data() {
            return {
                deviceId: this.$route.params.id,
                inspectDeviceDetail: {
                    device: {},
                    handleUser: {}
                }
            }
        },
        computed: {
            handleMethod() {
                return DICT.getValue("INSPECT_TSAK_DEVICE_HANDLE_METHOD", this.inspectDeviceDetail.handleMethod)
            }
        },
        created() {
        },
        mounted() {
            this.getInspectDeviceDetail()
        },
        methods: {
            getInspectDeviceDetail() {
                this.$http.tokiot.inspectTask.inspectDetail({id: this.deviceId})
                    .then(res => {
                        if (res) {
                            this.inspectDeviceDetail = res;
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 0px;
        width: calc(100% - 16px);
    }

    .top-title {
        margin: 15px 10px;
        background: #eceaea;
        font-size: 18px;
        font-weight: 500;
    }

</style>